import {
  Badge,
  Chip,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Typography,
  Stack,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import TodayIcon from '@mui/icons-material/Today';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Link as RouterLink } from 'react-router-dom';
import { usePatientTodoSummary } from '../../hooks/usePatientTodoSummary';

const todoIconById = {
  questions: <QuestionAnswerIcon fontSize="small" />,
  'daily-checkin': <TodayIcon fontSize="small" />,
  'weekly-checkin': <EventRepeatIcon fontSize="small" />,
  'monthly-checkin': <CalendarMonthIcon fontSize="small" />,
};

export const PatientSidebarTodo = () => {
  const { todoItems, dueCount } = usePatientTodoSummary();
  const dueItems = todoItems.filter((item) => item.due);

  return (
    <List
      dense
      subheader={
        <ListSubheader component="div" sx={{ bgcolor: 'transparent', lineHeight: 1.8 }}>
          <Stack
            component={RouterLink}
            to="/patient/notifications"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              pr: 1,
              textDecoration: 'none',
              cursor: 'pointer',
              '&:hover': { opacity: 0.8 },
            }}
          >
            <Typography variant="overline" color="text.secondary">
              To-Do
            </Typography>
            <Badge badgeContent={dueCount} color={dueCount > 0 ? 'error' : 'default'}>
              <Chip
                icon={<NotificationsIcon />}
                label={dueCount}
                size="small"
                color={dueCount > 0 ? 'warning' : 'default'}
                variant={dueCount > 0 ? 'filled' : 'outlined'}
                sx={{ cursor: 'pointer' }}
              />
            </Badge>
          </Stack>
        </ListSubheader>
      }
    >
      {dueItems.length === 0 ? (
        <ListItem>
          <ListItemText primary="View All Notifications" secondary="Click to see details" />
        </ListItem>
      ) : (
        dueItems.map((item) => (
          <ListItem key={item.id} disablePadding>
            <ListItemButton component={RouterLink} to="/patient/notifications">
              <ListItemIcon sx={{ minWidth: 28 }}>
                {item.count && item.count > 0 ? (
                  <Badge badgeContent={item.count} color="error">
                    {todoIconById[item.id]}
                  </Badge>
                ) : (
                  todoIconById[item.id]
                )}
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                secondary={item.helperText}
                primaryTypographyProps={{ variant: 'body2' }}
                secondaryTypographyProps={{ variant: 'caption' }}
              />
            </ListItemButton>
          </ListItem>
        ))
      )}
    </List>
  );
};
